import React from "react";
import { ProgressBar } from "react-bootstrap";

export default class CountDownTimer extends React.Component {
  constructor(props) {
    super(props);
    const refreshSeconds = props.refreshSeconds ?? 0;
    const refreshStandard = (100 / props.refreshSeconds);
    const isInfinite = props.isInfinite ?? false;
    const onRefresh = props.onRefresh ?? null;

    this.state = {
      refreshSeconds,
      refreshStandard,
      isInfinite,
      onRefresh
    };

    this.timer = null;
  }

  componentDidMount() {
    if (this.state.refreshSeconds > 0) {
      this.startTimer();
    }
  }

  componentWillUnmount() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  startTimer = () => {
    if (!this.timer && this.state.refreshSeconds > 0) {
      this.timer = setInterval(this.countDown, 1000);
    }
  };

  countDown = () => {
    const { refreshSeconds, isInfinite } = this.state;
    const { onRefresh, refreshSeconds: initialSeconds, onChange } = this.props;

    const seconds = refreshSeconds - 1;

    if (seconds === 0) {
      if (onRefresh) {
        
        onRefresh();
      }

      if (!isInfinite) {
        clearInterval(this.timer);
        this.timer = null;
      }
      onChange && onChange(initialSeconds);
      this.setState({
        refreshSeconds: initialSeconds,
      });
    } else {
      onChange && onChange(seconds);
      this.setState({
        refreshSeconds: seconds,
      });
    }
  };

  render() {
    const { refreshSeconds, refreshStandard } = this.state;
    return (
      <ProgressBar
        variant="custom-progressbar"
        label={`${refreshSeconds}초`}
        now={refreshSeconds * refreshStandard}
      />
    );
  }
}
